import { setHtml } from './css.js';
import { RowState } from './dataset.js';
import { esc, onOutsideMouseDown, mountPopup, fixFixedPos } from './grid-util.js';
import { lazy } from './grid-export.js';
export class GridMenu {
    // ═══════════════════════ 우클릭 메뉴·컬럼 선택기 ═══════════════════════
    closePopup() { this.popClose?.(); this.popClose = null; this.popEl?.remove(); this.popEl = null; }
    /** 목록 메뉴 띄우기 */
    showMenu(items, x, y) {
        this.closePopup();
        this.closeFilterMenu();
        const m = document.createElement('div');
        m.className = 'og-menu og-cmenu' + (this.touchOn ? ' og-tmenu' : '');
        m.setAttribute('role', 'menu');
        const list = items.filter((it, i, a) => !(it.sep && (i === 0 || a[i - 1].sep || i === a.length - 1)));
        setHtml(m, list.map((it, i) => it.sep ? '<div class="og-msep" role="separator"></div>'
            : `<button type="button" role="menuitem" data-i="${i}"${it.disabled ? ' disabled' : ''}><span class="og-mck">${it.checked ? '✓' : ''}</span><span>${esc(it.label ?? '')}</span><em>${esc(it.hint ?? '')}</em></button>`).join(''));
        mountPopup(this, m);
        this.popEl = m;
        m.style.left = Math.max(4, Math.min(x, window.innerWidth - m.offsetWidth - 4)) + 'px';
        m.style.top = Math.max(4, Math.min(y, window.innerHeight - m.offsetHeight - 4)) + 'px';
        fixFixedPos(m);
        m.addEventListener('click', e => {
            const b = e.target.closest('button[data-i]');
            if (!b)
                return;
            const it = list[+b.dataset.i];
            this.closePopup();
            it.action?.();
        });
        m.addEventListener('keydown', e => {
            const bs = [...m.querySelectorAll('button:not([disabled])')];
            const i = bs.indexOf(document.activeElement);
            if (e.key === 'Escape') {
                this.closePopup();
                this.focusGrid();
            }
            else if (e.key === 'ArrowDown') {
                e.preventDefault();
                bs[(i + 1) % bs.length]?.focus();
            }
            else if (e.key === 'ArrowUp') {
                e.preventDefault();
                bs[(i - 1 + bs.length) % bs.length]?.focus();
            }
        });
        const outside = (e) => { if (!m.contains(e.target))
            this.closePopup(); };
        this.popClose = onOutsideMouseDown(outside);
        m.querySelector('button:not([disabled])')?.focus();
    }
    /** @internal */ onHeaderContext(e) {
        if (this.opts.contextMenu === false)
            return;
        const hc = e.target.closest('.og-hc[data-ci]');
        e.preventDefault();
        if (this.opts.customize === 'developer' || this.opts.customize === 'user')
            lazy.designer().catch(() => { }); // "그리드 설정…" 을 누르기 전에 미리
        const c = hc ? this.cols[+hc.dataset.ci] : null;
        const items = [];
        const can = this.opts.customize !== 'none';
        if (c && !c.special) {
            const id = c.id;
            const sortDir = this.sortKeys.find(k => k.col === id)?.dir;
            const grouped = this.groupCols().includes(id);
            items.push({ label: this.t('오름차순 정렬'), checked: sortDir === 'asc', action: () => { this.setSort([{ col: id, dir: 'asc' }]); this.notifyLayout(); } }, { label: this.t('내림차순 정렬'), checked: sortDir === 'desc', action: () => { this.setSort([{ col: id, dir: 'desc' }]); this.notifyLayout(); } }, { label: this.t('정렬 해제'), disabled: !this.sortKeys.length, action: () => { this.setSort([]); this.notifyLayout(); } }, { sep: true }, grouped ? { label: this.t('이 컬럼 그룹 해제'), action: () => this.removeGroup(id) } : { label: this.t('이 컬럼으로 그룹'), action: () => this.addGroup(id) }, { label: this.t('그룹 패널 표시'), checked: !!this.opts.showGroupPanel, action: () => { this.setOptions({ showGroupPanel: !this.opts.showGroupPanel }); this.renderGroupPanel(); this.notifyLayout(); } }, ...(this.isGrouped() ? [{ label: this.t('그룹 모두 펼치기'), action: () => this.expandAllGroups() }, { label: this.t('그룹 모두 접기'), action: () => this.collapseAllGroups() }] : []), { sep: true }, { label: this.t('필터…'), disabled: !this.menuFilterable(c), action: () => this.openFilterMenu(id) }, { label: this.t('이 컬럼 필터 지우기'), disabled: !this.menuFilters.has(id), action: () => this.setColumnFilter(id, null) }, { sep: true }, { label: this.t('최적 너비'), disabled: !can, action: () => this.bestFit(id) }, { label: this.t('모든 컬럼 최적 너비'), disabled: !can, action: () => this.bestFit() }, { label: this.t('왼쪽 고정'), checked: c.def.pinned === true || c.def.pinned === 'left', disabled: !can, action: () => this.setColumnProperty(id, 'pinned', c.def.pinned === true || c.def.pinned === 'left' ? false : 'left') }, { label: this.t('오른쪽 고정'), checked: c.def.pinned === 'right', disabled: !can, action: () => this.setColumnProperty(id, 'pinned', c.def.pinned === 'right' ? false : 'right') }, { label: this.t('이 컬럼 숨기기'), disabled: !can, action: () => this.setColumnVisible(id, false) });
        }
        items.push({ label: this.t('컬럼 표시/순서…'), disabled: !can, action: () => this.openColumnChooser() }, { sep: true }, { label: this.t('필터 행 표시'), checked: !!this.opts.showFilterRow, action: () => { this.setOptions({ showFilterRow: !this.opts.showFilterRow }); this.notifyLayout(); } }, { label: this.t('합계 행 표시'), checked: !!this.opts.showFooter, action: () => { this.setOptions({ showFooter: !this.opts.showFooter }); this.notifyLayout(); } }, { label: this.t('필터 편집…'), action: () => this.openFilterBuilder() }, { label: this.t('찾기'), hint: 'Ctrl+F', disabled: this.opts.findPanel === false, action: () => this.openFind() }, { sep: true }, { label: this.t('그리드 설정…'), disabled: this.opts.customize !== 'developer' && this.opts.customize !== 'user', action: () => this.openDesigner() }, { label: this.t('화면 설정 초기화'), disabled: !can, action: () => this.resetLayout() });
        this.showMenu(items, e.clientX, e.clientY);
    }
    /** @internal */ onCellContext(e) {
        if (this.opts.contextMenu === false)
            return;
        const h = this.hit(e);
        if (!h)
            return;
        e.preventDefault();
        lazy.chart().catch(() => { }); // "차트로 보기…" 를 누르기 전에 미리 (1.2.0 지연 로딩)
        const row = this.disp[h.vi];
        const inRange = (() => { const r = this.range(); return h.vi >= r.r0 && h.vi <= r.r1 && h.ci >= r.c0 && h.ci <= r.c1; })() || this.inExtra(h.vi, h.ci);
        if (!inRange)
            this.setFocus(h.vi, h.ci, false);
        const col = this.cols[h.ci]?.id;
        const custom = row >= 0 ? this.opts.onContextMenu?.({ row, col, grid: this }) ?? [] : [];
        const ed = !!this.opts.editable;
        const items = [
            ...custom, ...(custom.length ? [{ sep: true }] : []),
            { label: this.t('복사'), hint: 'Ctrl+C', action: () => { this.ime.focus(); document.execCommand('copy'); } },
            { label: this.t('머리글 포함 복사'), hint: 'Ctrl+Shift+C', action: () => this.copyWithHeaders() },
            ...(ed ? [{ label: this.t('잘라내기'), hint: 'Ctrl+X', action: () => { this.ime.focus(); document.execCommand('cut'); } }] : []),
            ...(this.notesOn() && row >= 0 && col && !this.cols[h.ci]?.special ? (this.ds.getNote(row, col)
                ? ((ro) => [{ label: this.t('메모 편집…'), disabled: ro, action: () => this.editNote(row, col) }, { label: this.t('메모 삭제'), disabled: ro, action: () => { void this.setNote(row, col, null); } }])(this.opts.notes === 'read' || this.opts.noteCanEdit?.(this.ds.getNote(row, col)) === false)
                : [{ label: this.t('메모 추가…'), disabled: this.opts.notes === 'read', action: () => this.editNote(row, col) }]) : []),
            ...(row >= 0 ? (this.pinList[0].includes(row) || this.pinList[1].includes(row) ? [{ label: this.t('행 고정 해제'), action: () => this.pinRow(row, null) }] : [{ label: this.t('이 행 위에 고정'), action: () => this.pinRow(row, 'top') }]) : []),
            { label: this.t('셀 값으로 필터'), disabled: row < 0 || !col || !this.cellFilterable(h.ci), action: () => { const v = this.valueOf(this.cols[h.ci], row); this.setColumnFilter(col, { values: [v == null ? '' : String(v)] }); } },
            ...(row >= 0 && this.cols[h.ci]?.def.privacy && this.cols[h.ci]?.def.unmask ? [{ label: this.revealed.has(row + ':' + col) ? this.t('다시 가리기') : this.t('마스킹 해제'), hint: 'Ctrl+Shift+U', action: () => this.toggleUnmask(row, col) }] : []),
            { label: this.t('셀 값 제외 필터'), disabled: row < 0 || !col || !this.cellFilterable(h.ci), action: () => { const v = this.valueOf(this.cols[h.ci], row); this.setColumnFilter(col, { cond: { op: v == null ? 'notEmpty' : '!=', value: v } }); } },
            { sep: true },
            ...(ed ? [
                { label: this.t('행 추가'), hint: 'Insert', action: () => this.addRow(undefined, true, 'menu') },
                // 삭제 행 표시 중 삭제 행에서는 "삭제 취소"
                ...(this.opts.showDeletedRows && row >= 0 && this.ds.rowState(row) === RowState.DELETE ? [{ label: this.t('삭제 취소'), hint: 'Ctrl+Delete', action: () => { this.restoreRows(); } }]
                    : [{ label: this.t('행 삭제'), hint: 'Ctrl+Delete', action: () => { void this.deleteRows(undefined, { source: 'menu' }); } }]),
                { label: this.t('변경 취소'), action: () => this.revertRows() },
                { label: this.t('실행 취소'), hint: 'Ctrl+Z', disabled: !this.undoStack.length, action: () => this.undo() },
                { label: this.t('다시 실행'), hint: 'Ctrl+Y', disabled: !this.redoStack.length, action: () => this.redo() },
                { label: this.t('찾아 바꾸기…'), hint: 'Ctrl+H', action: () => this.openReplace() },
                { label: this.t('실행 취소 기록…'), disabled: !this.undoStack.length && !this.redoStack.length, action: () => this.openUndoHistory() },
                { sep: true },
            ] : []),
            ...(row >= 0 && this.opts.dragSource ? this.dropTargets().map((og, i) => ({ label: this.t('다른 그리드로 보내기') + (this.dropTargets().length > 1 ? ': ' + (og.root.getAttribute('aria-label') ?? i + 1) : ''), hint: i ? undefined : 'Alt+Shift+→', action: () => { this.sendRows(og); } })) : []),
            { label: this.t('차트로 보기…'), disabled: row < 0, action: () => this.openRangeChart('bar') }, // 메뉴를 열 때 차트 모듈을 미리 불러 둠 (아래 lazy.chart)
            { label: this.t('엑셀로 내보내기'), action: () => this.exportXlsx() },
            { label: this.t('CSV로 내보내기'), action: () => this.exportCsv() },
            { label: this.t('찾기'), hint: 'Ctrl+F', disabled: this.opts.findPanel === false, action: () => this.openFind() },
        ];
        this.showMenu(items, e.clientX, e.clientY);
    }
    /** 컬럼 표시/숨김·순서 (QuantumGrid Quick Customization, UltraGrid Column Chooser) */
    openColumnChooser() {
        this.closePopup();
        const m = document.createElement('div');
        m.className = 'og-menu og-chooser';
        m.setAttribute('role', 'dialog');
        m.setAttribute('aria-label', this.t('컬럼 표시와 순서'));
        const draw = () => {
            setHtml(m, `<b>${this.t('컬럼 표시 · 순서')}</b><div class="og-mlist">${this.opts.columns.map((c, i) => this.columnAccess(c) === 'hidden' ? '' : `<div class="og-chrow"><label><input type="checkbox" data-i="${i}"${c.hidden ? '' : ' checked'}> ${esc(c.header ?? c.id)}</label><span>${c.pinned ? (c.pinned === 'right' ? this.t('우고정') : this.t('좌고정')) : ''}</span><button type="button" data-up="${i}" title="${this.t('위로')}"${i ? '' : ' disabled'}>↑</button><button type="button" data-down="${i}" title="${this.t('아래로')}"${i < this.opts.columns.length - 1 ? '' : ' disabled'}>↓</button></div>`).join('')}</div>
<div class="og-mrow og-mbtns"><button type="button" data-a="all">${this.t('모두 표시')}</button><button type="button" data-a="close" class="og-mok">${this.t('닫기')}</button></div>`);
        };
        draw();
        mountPopup(this, m);
        this.popEl = m;
        m.addEventListener('change', e => { const t = e.target; const c = this.opts.columns[+t.dataset.i]; this.setColumnVisible(c.id, t.checked); });
        m.addEventListener('click', e => {
            const b = e.target.closest('button');
            if (!b)
                return;
            const cols = [...this.opts.columns];
            if (b.dataset.up != null || b.dataset.down != null) {
                const i = +(b.dataset.up ?? b.dataset.down), j = b.dataset.up != null ? i - 1 : i + 1;
                [cols[i], cols[j]] = [cols[j], cols[i]];
                this.setColumns(cols, this.opts.headerGroups);
                this.notifyLayout();
                draw();
            }
            else if (b.dataset.a === 'all') {
                this.setColumns(cols.map(c => ({ ...c, hidden: false })), this.opts.headerGroups);
                this.notifyLayout();
                draw();
            }
            else if (b.dataset.a === 'close') {
                this.closePopup();
                this.focusGrid();
            }
        });
        m.addEventListener('keydown', e => { if (e.key === 'Escape') {
            this.closePopup();
            this.focusGrid();
        } });
        this.placePopup(m, this.head);
        const outside = (e) => { if (!m.contains(e.target))
            this.closePopup(); };
        this.popClose = onOutsideMouseDown(outside);
    }
}
